import React from 'react';

import CommonLayout from '~components/CommonLayout';
import { RuntimeError } from '~components/errors';
import PageMeta from '~components/metas/PageMeta';

export default function CustomError() {
  return (
    <>
      <PageMeta />
      <CommonLayout>
        <RuntimeError />
      </CommonLayout>
    </>
  );
}
